"use strict";

import pdfmake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts.js";

const docDefinition = {
    "pageSize": "A4",
    "pageOrientation": "portrait",
    "pageMargins": [25, 25, 25, 25],
    "content": [],
    "defaultStyle": {
        "font": "GenShin",
    },
    "styles": {
        "title": {
            "bold": true,
            "fontSize": 18,
            "margin": [0, 0, 0, 8],
        },
        "text": {
            "fontSize": 14,
            "margin": [0, 0, 0, 16],
        },
        "table": {
            "fontSize": 9,
        },
        "tableStamp": {
            "fontSize": 10,
        },
        "tableVehicleInspections": {
            "fontSize": 4,
        },
    },
};

export default {
    "methods": {
        $_resetPdf(option) {
            if (option.pageOrientation) {
                docDefinition.pageOrientation = option.pageOrientation;
            }
            docDefinition.content = [];
        },
        $_addPdfContent(data) {
            docDefinition.content.push(data);
        },
        $_pdfDownload(fileName = "file") {
            pdfmake.fonts = {
                "GenShin": {
                    "normal": "GenShinGothic-Normal-Sub.ttf",
                    "bold": "GenShinGothic-Normal-Sub.ttf",
                    "italics": "GenShinGothic-Normal-Sub.ttf",
                    "bolditalics": "GenShinGothic-Normal-Sub.ttf",
                },
            };
            pdfmake.createPdf(docDefinition).download(fileName);
        },
    },
};
